import { getRequiredStringEnv } from './safeEnvParsing';

export const logError = (error: $TSFixMe) => {
  if (getRequiredStringEnv('NODE_ENV') === 'development') {
    console.error(error);
  }
};
